import { Set as ImmutableSet } from 'immutable';
import invariant from '../../lib/invariant';
export const idsSetInvariant = ids => {
  invariant(ImmutableSet.isSet(ids), 'Expected ids to be a Set not a %s', typeof ids);
};